import React from 'react';
import '../styles/Loader.scss';
import img from '../helpers/img';

const Loader = ({ name }) => (
  <img className="Loader" src={img(`svg/${name}.svg`)} alt="" />
);

Loader.propTypes = {
  name: React.PropTypes.string.isRequired
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.js